import axios from "axios";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_CORE_API}/api`,
});

export default instance;
